__turbopack_context__.v({
  "container": "hero-module__9tsWTa__container",
  "controlsContainer": "hero-module__9tsWTa__controlsContainer",
  "video": "hero-module__9tsWTa__video",
});
